import * as React from 'react'
import { SVGProps } from 'react'
const SvgTieClips = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 20 20" xmlSpace="preserve" {...props}>
    <path d="M19.4 11.8H2.2c-.6 0-1.1-.5-1.1-1.1-.1-.6.3-1.1.9-1.2h.2c1.4.1 2.7.4 4 .7 2.3.6 4.6 1 7 1.1 4.1 0 4.2-1.8 4.2-2 0-.3-.2-.5-.5-.5s-.5.2-.5.5-.7 1-3.2 1c-2.3-.1-4.6-.5-6.8-1.1-1.4-.3-2.8-.6-4.2-.7-1.1-.1-2.1.8-2.1 1.9v.2c0 1.2 1 2.1 2.1 2.1h17.2c.3 0 .5-.2.5-.5s-.2-.4-.5-.4z" />
  </svg>
)
export default SvgTieClips
